









































































































import StudentBaseInformation from "./StudentBaseInformation.vue";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "studentApplyDetailBase",
  components: {
    StudentBaseInformation,
  },
})
export default class extends Vue {
  @Prop() public studentInfoDto!: any;
  @Prop() public studentDto!: any;

  get getAttachmentInfo() {
    return (fileList: any) => {
      if (fileList && fileList.length) {
        return fileList.map((item: any) => item.typeKey).join(",");
      }
      return "";
    };
  }
}
